import "../../assets/scss/components/templates/heading.scss";

const Heading = ({ text, heading }) => {
  return (
    <div className="heading">
      <h1 className="heading-1" dangerouslySetInnerHTML={{ __html: heading }} />
      <p className="paragraph-small-regular">{text}</p>
    </div>
  );
};

export default Heading;
